import firebase from "firebase";

const config = {
  apiKey: "AIzaSyDHB5euoIS_fBONCp3I93xyW_3sko4mVnA",
  authDomain: "fir-amst-8de23.firebaseapp.com",
  databaseURL: "https://fir-amst-8de23.firebaseio.com",
  projectId: "fir-amst-8de23",
  storageBucket: "fir-amst-8de23.appspot.com",
  messagingSenderId: "627534504143"
};
firebase.initializeApp(config);

export const auth = firebase.auth();
export const LOCAL = firebase.auth.Auth.Persistence.LOCAL;
export const realtimeDB = firebase.database();
export const TIMESTAMP = firebase.database.ServerValue.TIMESTAMP;
export const Timestamp = firebase.firestore.Timestamp;
export const storage = firebase.storage().ref();
//FIRESTORE
export const firestore = firebase.firestore();
const settings = { timestampsInSnapshots: true };
export const emailAuthProvider = firebase.auth.EmailAuthProvider;
firestore.settings(settings);



// WEBPACK FOOTER //
// ./src/_firebase/index.js